import CLMS from "../../Assets/logos/clms_logo.svg";
import Carzlane from "../../Assets/logos/carzlane_logo.svg";
import Ronsautomotive from "../../Assets/logos/ronsautomotive_logo.svg";

const dealershipInfo = {
  "6519811bfdc671137c99a40c": {
    logo: Carzlane,
    favIconSize: "10x40",
    name: "Carzlane",
    address: "2747 Annapolis Rd",
    city: "Hanover",
    state: "MD",
    zipCode: "21076",
    phoneNumber: "(240) 307-3416",
    email: "support@carzlane.com",
    mapLocation:
      "https://www.google.com/maps/place/Carzlane/@39.1372636,-76.7542001,17z/data=!3m1!4b1!4m6!3m5!1s0x89b7e7494d4a5d3d:0xdad828ac2746ad2d!8m2!3d39.1372595!4d-76.7516198!16s%2Fg%2F11rhbwyjnn?entry=ttu",
    facebook: "https://www.facebook.com/carzlanellc/",
    twitter: "https://twitter.com",
    instagram: "https://www.instagram.com/explore/locations/109467621477718/carzlane/",
    youtube: "https://www.youtube.com",
    tiktok: "https://www.tiktok.com/@carzlane",
    linkedin: "https://www.linkedin.com/company/carzlane-inc/",
  },
  "651adc0f5506270014cc3208": {
    logo: Ronsautomotive,
    favIconSize: "40x30",
    name: "Ron's Automotive",
    address: "4028 Hanover Pike",
    city: "Manchester",
    state: "MD",
    zipCode: "21102",
    phoneNumber: "410-239-3180",
    email: "sayam@rons-automotive.com",
    mapLocation:
      "https://www.google.com/maps/place/Ron%27s+Automotive/@39.6853741,-76.8943167,15z/data=!4m2!3m1!1s0x0:0x20684cd6118a2820?sa=X&ved=2ahUKEwjE8ZSluviDAxUomIkEHcxLDZIQ_BJ6BAhHEAA",
    facebook: "https://www.facebook.com/ManchesterRonsAutomotive/",
    twitter: "https://twitter.com/ronsautomd",
    instagram: "https://www.instagram.com/RonsAutomotive/",
    youtube: "https://www.youtube.com",
    tiktok: "https://www.tiktok.com",
    linkedin: "https://www.linkedin.com/company/rons-automotive",
  },
  CLMS: {
    logo: CLMS,
    favIconSize: "40x40",
    name: "CLMS",
    address: "1234 Main St",
    city: "San Diego",
    state: "CA",
    zipCode: "92101",
    phoneNumber: "555-555-5555",
    email: "carzlanems@gmail.com",
    mapLocation: "",
    facebook: "https://www.facebook.com/CLMS/",
    twitter: "https://twitter.com/CLMS",
    instagram: "https://www.instagram.com/CLMS",
    youtube: "https://www.youtube.com/CLMS",
    tiktok: "https://www.tiktok.com/CLMS",
    linkedin: "https://www.linkedin.com/CLMS",
  },
};

export default dealershipInfo;
